import React from 'react';
import { View } from '@react-pdf/renderer';
import RichText from 'PDF/TemplateEngine/atoms/RichText';
import SectionHeader from 'PDF/TemplateEngine/atoms/SectionHeader';

// Body type 'text-rich'. config: { textKey?, body, align? }
function RichTextSection({ section, data }) {
  const cfg = section?.config || {};
  return (
    <View>
      {section?.title ? <SectionHeader title={section.title} /> : null}
      <RichText textKey={cfg.textKey} body={cfg.body} data={data} align={cfg.align} />
    </View>
  );
}

export default RichTextSection;
